import React, {useState} from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";


const MenuDots = ({options}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleOpen = (e) => {
        setAnchorEl(e.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleClick = (option) => {
        handleClose();
        option.onClick();
    }

    return <Box sx={{color: "inherit"}}>
        <IconButton
            aria-controls="top-bar-menu"
            aria-haspopup="true"
            edge="end"
            aria-label="comments"
            onClick={handleOpen}
            sx={{color: "inherit"}}>
            <MoreVertIcon sx={{color: "inherit"}}/>
        </IconButton>

        <Menu
            id="booking-action-menu"
            anchorEl={anchorEl}
            keepMounted
            open={menuOpen}
            onClose={handleClose}>
            {
                options.map(option =>
                    <MenuItem key={option.label} onClick={() => handleClick(option)} disabled={!!option.disabled}>
                        {
                            option.icon && <ListItemIcon>{option.icon}</ListItemIcon>
                        }
                        <ListItemText>{option.label}</ListItemText>
                    </MenuItem>
                )
            }
        </Menu>
    </Box>
}

MenuDots.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        icon: PropTypes.element,
    })).isRequired,
}

export default MenuDots;